import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { savingNodesPositions } from '../actions/scrolling';
import Contact from '../components/Contact';
import AboutGas from '../components/gas/AboutGas';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import NavigationBar from '../components/NavigationBar';
import { getEvents } from '../actions/EventsAction';
import { getAllGallerie, getAllVideos } from '../actions/GallerieAction';
import Events from '../components/Events';
import AndroidIcon from '../assets/images/logo/android-logo.svg';
import AppleIcon from '../assets/images/logo/apple-logo.svg';
import StoreButton from '../components/StoreButton';

const HeaderContent = (
  <Fragment>
    <h1 className="txt-cover pt-x">
      A different
      <span style={{ fontWeight: 900 }}>
        {' '}
        Experience
        <span style={{ color: '#ff00f6' }}>.</span>
      </span>
    </h1>
    <div className="row justify-content-center text-left pt-5">
      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.gas.mobile">
        <StoreButton icon={AndroidIcon} textOne="Available on" textTwo="Google store" />
      </a>
      <a target="_blank" href="https://itunes.apple.com/us/app/gas-univers/id1420409907">
        <StoreButton icon={AppleIcon} textOne="Available on" textTwo="Apple store" />
      </a>
    </div>
  </Fragment>
);

class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      items: [],
      images: [],
    };
  }

  componentDidMount() {
    this.props.getEvents();
    this.props.getAllGallerie();
    this.props.getAllVideos();
    const about = ReactDOM.findDOMNode(this.refs.about);
    const events = ReactDOM.findDOMNode(this.refs.events);
    const gallery = ReactDOM.findDOMNode(this.refs.gallery);
    const contact = ReactDOM.findDOMNode(this.refs.contact);
    this.props.savingNodesPositions({
      main: {
        about: about.offsetTop,
        events: events.offsetTop,
        gallery: gallery.offsetTop,
        contact: contact.offsetTop,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Header content={HeaderContent} background="gas-header-bg">
          <NavigationBar
            slug="main"
            navigations={[
              { name: 'about', txt: 'About' },
              { name: 'events', txt: 'Events' },
              { name: 'gallery', txt: 'Gallery' },
              { name: 'contact', txt: 'Contact' },
            ]}
          />
        </Header>
        <section className="gas-about-bg">
          <AboutGas ref="about" />
          <Events ref="events" showPlace data={this.props.events} />
        </section>
        <Gallery ref="gallery" background="gas-gallery-bg" medias={this.props.gallerie} />
        <Contact ref="contact" color="#d62991" palceholders="#5400fb" background="gas-about-bg" info={info} />
        <Footer color="#d62991" secondColor="#340725" />
      </Fragment>
    );
  }
}

const info = {
  facebook: '',
  insta: '',
  youtube: 'https://www.youtube.com/channel/UCvZWA5TdcWRmHta1bEWIAMg',
  tripAdvisor: '',
  address: (
    <span>
      Golf Advanced Services, Port El Kantaoui,Hammam Sousse,4089 <br />
      Siége social : A 6-4,Immeuble Venus, centre Urbain Nord, 1003 Tunis.
    </span>
  ),
};

const mapStateToProps = store => ({
  scrolling: store.scrolling,
  events: store.events,
  gallerie: store.gallerie,
});

export default connect(mapStateToProps, {
  savingNodesPositions,
  getAllGallerie,
  getEvents,
  getAllVideos,
})(IndexPage);



// WEBPACK FOOTER //
// ./src/pages/index.jsx